export const defaultValuesForm = {
  name: '',
  isHost: false,
  isOperator: false,
  accessType: null,
  operatorMenu: [],
  hostMenu: [],
};

export const buildOptionsAksesWebsite = (t) => [
  {
    label: t('optionDesktopWebsite'),
    value: 'Desktop Website',
  },
  {
    label: t('optionMobileWebsite'),
    value: 'Mobile Website',
  },
];